export default "__VITE_ASSET__Df6_QCT$__"